(() => {
  function init(gallery) {
    gallery.__starbookCleanup?.();
    const track = gallery.querySelector('[data-starbook-track]');
    const slides = [...gallery.querySelectorAll('[data-starbook-slide]')];
    if (!track || !slides.length) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const thumbs = [...gallery.querySelectorAll('[data-starbook-thumb]')];
    const rail = gallery.querySelector('[data-starbook-thumbs]');
    const prev = gallery.querySelector('[data-starbook-prev]');
    const next = gallery.querySelector('[data-starbook-next]');
    const counter = gallery.querySelector('[data-starbook-counter]');
    let selected = 0;
    let frame = 0;
    let observer = null;
    function sync(index) {
      selected = Math.max(0, Math.min(slides.length - 1, index));
      thumbs.forEach((thumb, i) => {
        if (i === selected) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = selected === 0;
      if (next) next.disabled = selected === slides.length - 1;
      if (counter) counter.textContent = counter.dataset.format
        .replace('[current]', String(selected + 1)).replace('[total]', String(slides.length));
      const thumb = thumbs[selected];
      if (rail && thumb) {
        const box = rail.getBoundingClientRect();
        const item = thumb.getBoundingClientRect();
        if (item.top < box.top) rail.scrollTop += item.top - box.top;
        else if (item.bottom > box.bottom) rail.scrollTop += item.bottom - box.bottom;
        if (item.left < box.left) rail.scrollLeft += item.left - box.left;
        else if (item.right > box.right) rail.scrollLeft += item.right - box.right;
      }
    }
    // A click on an arrow or thumbnail slides the strip there (owner
    // 2026-10-05), as the story pages do; keys, a resize or reduced motion
    // move it at once.
    const reducedMotion = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: true };
    function show(index, animate) {
      sync(index);
      track.scrollTo({ left: selected * track.clientWidth, behavior: animate && !reducedMotion.matches ? 'smooth' : 'instant' });
    }
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', event => {
      event.preventDefault(); show(index, true);
    }, { signal }));
    prev?.addEventListener('click', () => show(selected - 1, true), { signal });
    // The product page asks for the framed-chart slide when the chart edition or a frame is chosen.
    gallery.addEventListener('starbook:show-chart', () => {
      const chart = slides.findIndex(slide => slide.hasAttribute('data-starbook-chart-slide'));
      if (chart >= 0) show(chart, true);
    }, { signal });
    next?.addEventListener('click', () => show(selected + 1, true), { signal });
    track.addEventListener('keydown', event => {
      const target = { ArrowLeft: selected - 1, ArrowRight: selected + 1, Home: 0, End: slides.length - 1 }[event.key];
      if (target === undefined) return;
      // Keyboard moves stay instant, as before.
      event.preventDefault(); show(target);
    }, { signal });
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        if (track.clientWidth) sync(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true, signal });
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(() => show(selected)); observer.observe(track);
    } else window.addEventListener('resize', () => show(selected), { signal });
    gallery.querySelector('[data-starbook-arrows]')?.toggleAttribute('hidden', slides.length < 2);
    sync(0);
    gallery.__starbookCleanup = () => { controller.abort(); observer?.disconnect(); if (frame) cancelAnimationFrame(frame); };
  }
  // Shop reviews scroll sideways; the arrows move one card, dim at either end
  // and stay hidden while every card fits (as on the story book pages).
  function initReviews(block) {
    if (block.dataset.initialized) return;
    const list = block.querySelector('[data-llsj-reviews-list]');
    const prev = block.querySelector('[data-llsj-reviews-prev]');
    const next = block.querySelector('[data-llsj-reviews-next]');
    if (!list || !prev || !next) return;
    block.dataset.initialized = 'true';
    function sync() {
      const overflow = list.scrollWidth - list.clientWidth;
      prev.hidden = next.hidden = overflow <= 1;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= overflow - 1;
    }
    function move(direction) {
      const card = list.querySelector('.llsj-reviews__item');
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({ left: direction * ((card ? card.getBoundingClientRect().width : list.clientWidth) + gap), behavior: reduce ? 'auto' : 'smooth' });
      requestAnimationFrame(sync);
    }
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    list.addEventListener('scroll', sync, { passive: true });
    list.addEventListener('scrollend', sync);
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(sync).observe(list);
    else window.addEventListener('resize', sync);
    sync();
  }
  const mount = () => {
    document.querySelectorAll('[data-starbook-gallery]').forEach(init);
    document.querySelectorAll('.ll-starbook [data-llsj-pdp-reviews]').forEach(initReviews);
  };
  mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('starbook:product-change', event => {
    const gallery = event.target && event.target.closest?.('[data-starbook-gallery]');
    if (gallery) init(gallery);
  });
})();
